import { render, staticRenderFns } from "./ProjectReview.vue?vue&type=template&id=a5f5f2bc&scoped=true&"
import script from "./ProjectReview.vue?vue&type=script&lang=js&"
export * from "./ProjectReview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReview.vue?vue&type=style&index=0&id=a5f5f2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f5f2bc",
  null
  
)

export default component.exports